import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { StyleSheet, View } from "react-native";
import { heightPercentageToDP as hp } from "../../../Utils/responsive";
import "../../../App.scss";
import First from "./firstIntropage";
import Second from "./secondIntroPage";
import Third from "./thirdIntroPage";
import ModuleTop from "../../../Components/Layout/Default/module-top";
export default function Index(props) {
  const [display, setDisplay] = useState(false);
  const [page1, setPage1] = useState(true);
  const [page2, setPage2] = useState(true);
  const [firstPageA, setFirstPageA] = useState(null);

  useLayoutEffect(() => {
    const delay = setTimeout(() => {
      setDisplay(true);
    }, 800); // starts after the top bar has finished animating

    return () => clearTimeout(delay);
  }, []);

  const pageOne = (id) => {
    setPage1(false);
    setFirstPageA(id);
  };
  const pageTwo = () => {
    setPage2(false);
  };

  return (
    <View style={[styles.container, { height: "100vh" }]}>
      <ModuleTop module="atr" active={true} />
      {display &&
        (page1 ? (
          <First {...props} pageOne={pageOne} />
        ) : page2 ? (
          <Second {...props} pageTwo={pageTwo} firstPageA={firstPageA} />
        ) : (
          <Third {...props} />
        ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100vw",
    //flex: 1,
    // backgroundColor: "#eeeeee",
    overflow: "hidden",
  },
});
